import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import api from '../../../services/api';
import '../../../pages/Proposal.css';
import PROPOSAL_MODELS from '../../data/proposalModels';

const MODEL_OPTIONS = [
  { key: 'A interno', label: 'Modelo A Interno' },
  { key: 'A externo', label: 'Modelo A Externo' },
  { key: 'A interno e externo', label: 'Modelo A Interno + Externo' },
  { key: 'C interno', label: 'Modelo C Interno' },
  { key: 'C externo', label: 'Modelo C Externo' },
  { key: 'C interno e externo', label: 'Modelo C Interno + Externo' }
];

export const SERVICES_BY_MODEL = {
  'A interno': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'detalhamento-mobiliario', label: 'Detalhamento interno de mobiliário' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: '10-imagens-internas', label: '10 imagens internas 3D realistas FULL HD' },
    { id: '20-imagens-internas', label: '20 imagens internas 3D realistas FULL HD' },
    { id: 'video-interno', label: '1 Vídeo interno realista em FULL HD de 60seg.' }
  ],

  'A externo': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: '10-imagens-externas', label: '10 imagens externas 3D realistas FULL HD' },
    { id: '20-imagens-externas', label: '20 imagens externas 3D realistas FULL HD' },
    { id: 'video-externo', label: '1 Vídeo externo realista em FULL HD de 60seg.' }
  ],

  'A interno e externo': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'detalhamento-mobiliario', label: 'Detalhamento interno de mobiliário' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: '10-imagens-ex-int', label: '10 imagens externas/internas 3D realistas FULL HD' },
    { id: '20-imagens-ex-int', label: '20 imagens externas/internas 3D realistas FULL HD' },
    { id: 'video-ex-int', label: '1 Vídeo externo/interno realista em FULL HD de 60seg.' }
  ],

  'C interno': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'detalhamento-interno-medidas', label: 'Detalhamento interno básico com medidas' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: 'cenografia-basica', label: 'Cenografia básica' },
    { id: '10-imagens-internas', label: '10 imagens internas 3D realistas FULL HD' },
    { id: '20-imagens-internas', label: '20 imagens internas 3D realistas FULL HD' },
    { id: 'video-interno', label: '1 Vídeo interno realista em FULL HD de 60seg.' }
  ],

  'C externo': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'detalhamento-externo-medidas', label: 'Detalhamento básico com medidas' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: 'cenografia-basica', label: 'Cenografia básica' },
    { id: '10-imagens-externas', label: '10 imagens externas 3D realistas FULL HD' },
    { id: '20-imagens-externas', label: '20 imagens externas 3D realistas FULL HD' },
    { id: 'video-externo', label: '1 Vídeo externo realista em FULL HD de 60seg.' }
  ],

  'C interno e externo': [
    { id: 'desenvolvimento-fachada', label: 'Desenvolvimento de Fachada' },
    { id: 'detalhamento-interno-medidas', label: 'Detalhamento interno básico com medidas' },
    { id: 'detalhamento-externo-medidas', label: 'Detalhamento externo básico com medidas' },
    { id: 'planta-baixa-basica', label: 'Planta baixa básica ilustrativa' },
    { id: 'planta-baixa-humanizada', label: 'Planta baixa humanizada em .png' },
    { id: 'cenografia-basica', label: 'Cenografia básica' },
    { id: '10-imagens-ex-int', label: '10 imagens externas/internas 3D realistas FULL HD' },
    { id: '20-imagens-ex-int', label: '20 imagens externas/internas 3D realistas FULL HD' },
    { id: 'video-ex-int', label: '1 Vídeo externo/interno realista em FULL HD de 60seg.' }
  ]
};

// Ensure combined models include services from both sides when appropriate
SERVICES_BY_MODEL['A interno e externo'] = [
  ...SERVICES_BY_MODEL['A interno'],
  ...SERVICES_BY_MODEL['A externo']
];

export default function ProposalCreate(){
  const navigate = useNavigate();
  const [projectModel, setProjectModel] = useState('');
  const [selectedModelData, setSelectedModelData] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [projectName, setProjectName] = useState('');
  const [clientSource, setClientSource] = useState('');
  const [productionDays, setProductionDays] = useState(''); // tempo de produção (dias)
  const [deliveryDeadline, setDeliveryDeadline] = useState(''); // prazo de entrega (dias úteis)
  const [projectPrice, setProjectPrice] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const availableServices = useMemo(() => SERVICES_BY_MODEL[projectModel] || [], [projectModel]);

  const toggleService = (svc) => {
    setSelectedServices(prev => prev.includes(svc) ? prev.filter(s => s !== svc) : [...prev, svc]);
  };

  const calcular = () => {
    const valor = parseFloat(String(productionDays).replace(',', '.')) || 0;
    if (!valor) { alert('Informe a quantidade de dias de produção e clique em Calcular'); return; }

    let resultadoCalculo = 0;
    if (valor <= 3) {
      resultadoCalculo = valor * 8 * 50;
    } else if (valor >= 3.5 && valor < 6) {
      resultadoCalculo = valor * 8 * 45;
    } else if (valor >= 6) {
      resultadoCalculo = valor * 8 * 37;
    }

    // Se selecionou vídeo, acrescenta taxa fixa de 350
    const hasVideo = selectedServices.some(s => s.label && s.label.toLowerCase().includes('vídeo'));
    if (hasVideo) resultadoCalculo += 350;

    setProjectPrice(Math.round(resultadoCalculo));
  };

  const subtotal = useMemo(() => (projectPrice || 0), [projectPrice]);
  const total = useMemo(() => subtotal, [subtotal]);

  const handleSave = async () => {
    if(!projectModel) return alert('Selecione um modelo');
    if(!projectName) return alert('Informe o nome do projeto');
    if(!clientName) return alert('Informe o nome do cliente');

    const user_id = localStorage.getItem('user');
    if(!user_id) {
      console.warn('user_id não encontrado em localStorage. Valor atual:', user_id);
      alert('Usuário não autenticado localmente. Faça login ou defina localStorage.setItem("user", "<seu_id>") antes de salvar.');
      return;
    }

    const payload = {
      project_model: projectModel,
      project_model_id: selectedModelData?.id || projectModel,
      project_model_title: selectedModelData?.title || projectModel,
      project_model_type: selectedModelData?.type || null,
      project_model_description: selectedModelData?.model || null,
      project_model_modelempty: selectedModelData?.modelempty || null,
      project_price: projectPrice || 0,
      clientName,
      clientPhone,
      projectName,
      clientSource,
      project_services: selectedServices.map(s => ({ id: s.id, label: s.label })),
      productionDays,
      projectDeadline: deliveryDeadline
    };

    console.log('[ProposalCreate.handleSave] 4. Payload enviado para POST /proposals:', payload);
    setIsSaving(true);
    try {
      const res = await api.post('/proposals', payload, { headers: { user_id, 'Content-Type': 'application/json' } });
      console.log('[ProposalCreate.handleSave] 5. Resposta de POST /proposals e prazo enviado:', {
        sentProjectDeadline: payload.projectDeadline,
        response: res.data
      });

      // Prepare endpoint mapping for PDF generation (matches existing public proposal pages)
      const ENDPOINTS = {
        'A interno': '/mvpproposals/aintern',
        'A externo': '/mvpproposals/aextern',
        'A interno e externo': '/mvpproposals/ainextern',
        'C interno': '/mvpproposals/cintern',
        'C externo': '/mvpproposals/cextern',
        'C interno e externo': '/mvpproposals/cinextern'
      };

      // Build payload shape expected by the PDF generator endpoints
      const pdfPayload = {
        clientName,
        projectName,
        projectPrice: total || projectPrice || 0,
        projectModelFirst: selectedModelData?.model || null,
        projectModelSecond: selectedModelData?.modelempty || null,
        projectServices: selectedServices.map(s => s.label),
        clientPhone,
        clientSource,
        currentDate: new Date().toLocaleDateString(),
        projectDeadline: deliveryDeadline,
        productionDays,
        projectModelType: selectedModelData?.type || null
      };

      // Try to generate and download PDF from backend
      try {
        const endpoint = ENDPOINTS[projectModel];
        const pdfRes = await api.post(endpoint, pdfPayload, { responseType: 'blob' });
        const blob = new Blob([pdfRes.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = `${pdfPayload.clientName} - ORÇAMENTO PROPOSTA DE INVESTIMENTO M3D STUDIO - ${pdfPayload.projectName}.pdf`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        setProjectModel('');
        setSelectedModelData(null);
        setSelectedServices([]);
        setClientName('');
        setClientPhone('');
        setProjectName('');
        setClientSource('');
        setProductionDays('');
        setDeliveryDeadline('');
        setProjectPrice(null);

        navigate('/system/proposals');
      } catch (err) {
        console.error('Erro ao gerar PDF:', err);
        alert('Orçamento criado, mas falha ao gerar o PDF. Verifique o servidor ou tente novamente.');
      }
    } catch (err) {
      console.error('Erro ao salvar proposta:', err.response || err.message);
      const msg = err.response && err.response.data ? JSON.stringify(err.response.data) : err.message;
      alert('Erro ao salvar. Detalhes: ' + msg);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1">
        <Topbar user={{ name: 'Mateus Teixeira' }} />

        <main className="p-6 max-w-7xl mx-auto">
          <div className="mb-6">
            <Link to="/system/proposals" className="text-sm text-gray-400 hover:text-gray-600">‹ Voltar para orçamentos</Link>
            <h2 className="text-2xl font-bold mt-3 -translate-y-1">Novo Orçamento</h2>
            <p className="mt-9 text-sm text-gray-500">Preencha as informações para criar um novo orçamento.</p>
          </div>

          <div className="flex gap-6">
            <div className="flex-1">
              <div className="bg-white rounded-2xl p-6 border">
                <h3>1. Tipo de orçamento</h3>
                <div className="grid grid-cols-3 gap-3 my-4">
                  {MODEL_OPTIONS.map(m => (
                    <div key={m.key} onClick={() => { setProjectModel(m.key); setSelectedModelData(PROPOSAL_MODELS[m.key] || null); }} className={`p-4 border rounded-lg cursor-pointer ${projectModel===m.key? 'border-purple-600 bg-purple-50':''}`}>
                      <div className="text-sm font-semibold">{m.label}</div>
                    </div>
                  ))}
                </div>

                <h3>2. Informações do cliente</h3>
                <div className="first-inner-container">
                  <label>Nome do cliente</label>
                  <input type="text" value={clientName} onChange={e => setClientName(e.target.value)} placeholder="Nome do cliente" />
                  <label>Telefone</label>
                  <input type="text" value={clientPhone} onChange={e => setClientPhone(e.target.value)} placeholder="(11) 98765-4321" />
                  <label>Nome do projeto</label>
                  <input type="text" value={projectName} onChange={e => setProjectName(e.target.value)} placeholder="Nome do projeto" />
                  <label>Como o cliente nos conheceu?</label>
                  <select value={clientSource} onChange={e => setClientSource(e.target.value)}>
                    <option value="">Selecione...</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Indicação">Indicação</option>
                    <option value="Google">Google</option>
                  </select>
                </div>

                <h3>3. Serviços disponíveis</h3>
                <div className="my-4">
                  {availableServices.length===0 && <div className="text-sm text-gray-500">Selecione um modelo para ver serviços disponíveis.</div>}
                  {availableServices.map(s => (
                    <label key={s.id} style={{display:'block', marginBottom:8}}>
                      <input type="checkbox" onChange={() => toggleService(s)} checked={selectedServices.includes(s)} /> {s.label}
                    </label>
                  ))}
                </div>

                <h3>4. Prazo e tempo de produção</h3>
                <div>
                  <label>Prazo de entrega (dias úteis)</label>
                  <input type="text" value={deliveryDeadline} onChange={e => setDeliveryDeadline(e.target.value)} placeholder="Ex.: 30" />
                  <label style={{marginTop:10}}>Tempo de produção (dias)</label>
                  <input type="text" value={productionDays} onChange={e => setProductionDays(e.target.value)} placeholder="Ex.: 2" />
                  <button type="button" onClick={calcular} className="mt-3 block px-4 py-2 bg-purple-600 text-white rounded-2xl">Calcular</button>
                </div>

                
              </div>
            </div>

            <aside style={{width:360}}>
              <div className="bg-white rounded-2xl p-6 border">
                <h3>Resumo do Orçamento</h3>
                <div style={{marginTop:12}}>
                  <div className="text-sm text-gray-500">Modelo selecionado</div>
                  <div className="font-semibold mt-1">{projectModel || '—'}</div>
                </div>

                <div style={{marginTop:12}}>
                  <div className="text-sm text-gray-500">Cliente</div>
                  <div className="mt-1">{clientName || '—'}</div>
                </div>

                <div style={{marginTop:12}}>
                  <div className="text-sm text-gray-500">Projeto</div>
                  <div className="mt-1">{projectName || '—'}</div>
                </div>

                <div style={{marginTop:12}}>
                  <div className="text-sm text-gray-500">Serviços</div>
                  <div className="mt-2 text-sm">
                    {selectedServices.map((s,i) => (
                      <div key={i} className="flex justify-between"><span>{s.label}</span><span>—</span></div>
                    ))}
                    {!selectedServices.length && <div className="text-sm text-gray-500">Nenhum serviço</div>}
                  </div>
                </div>

                <div style={{marginTop:16}}>
                  <div className="flex justify-between"><span>Subtotal</span><span>R$ {subtotal.toLocaleString('pt-BR')}</span></div>
                  <div className="mt-4 flex justify-between font-semibold text-lg"><span>Total</span><span>R$ {total.toLocaleString('pt-BR')}</span></div>
                </div>

                <button style={{marginTop:20}} onClick={handleSave} disabled={isSaving}>{isSaving ? 'Salvando...' : 'Salvar e gerar orçamento'}</button>
              </div>
            </aside>
          </div>
        </main>
      </div>
    </div>
  );
}
